export default __webpack_public_path__ + "static/media/cooking.bb8585b7.jpg";